import React from 'react'

import { useExecutionFormActions } from './_form/ExecutionFormHandler'
import { useQuestions } from './_load/FormLoader'
import { useSaveFormReply } from './_requests/saveFormReply'
import DynamicForm from '../../../containers/dynamic/form/DynamicForm'
import GeneralPanel from './general/GeneralPanel'

const ExecutionForm = () => {
  const questions = useQuestions()
  const { setForm } = useExecutionFormActions()
  const [submit, { loading }] = useSaveFormReply()

  return (
    <DynamicForm questions={questions} onChange={setForm} onSubmit={submit} loading={loading}>
      <GeneralPanel />
    </DynamicForm>
  )
}

export default ExecutionForm
